'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('./styleInject.js');

var css_248z = ".PanelContentHeader-module_alignLeft__67IhU{text-align:left}.PanelContentHeader-module_alignCenter__PaJT0{text-align:center}.PanelContentHeader-module_tableCell__SEFHD{display:table-cell;vertical-align:middle}";
var styles = {"alignLeft":"PanelContentHeader-module_alignLeft__67IhU","alignCenter":"PanelContentHeader-module_alignCenter__PaJT0","tableCell":"PanelContentHeader-module_tableCell__SEFHD"};
styleInject["default"](css_248z, '30254697-2989-46a4-a6e6-9cfe4e14067a');

exports["default"] = styles;
